import { useState } from 'react';

export default function Hero() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formBody = new URLSearchParams();
      formBody.append('nombre', formData.nombre);
      formBody.append('email', formData.email);
      formBody.append('telefono', formData.telefono);

      const response = await fetch('https://readdy.ai/api/form/d4ld244u6ftm2u5dbbtg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitMessage('¡Gracias! Te contactaremos pronto con tu estimación gratuita.');
        setFormData({ nombre: '', email: '', telefono: '' });
      } else {
        setSubmitMessage('Hubo un error. Por favor, intenta de nuevo.');
      }
    } catch (error) {
      setSubmitMessage('Hubo un error. Por favor, intenta de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/9b0b070c5149d413a3538dcc547a213b.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h1 className="font-['Andrea'] text-5xl lg:text-6xl xl:text-7xl font-bold mb-6 leading-tight">
              Convierte tu vivienda en ingresos pasivos sin mover un dedo.
            </h1>
            <p className="font-['Satoshi'] text-xl lg:text-2xl mb-8 text-gray-100 leading-relaxed">
              Nos encargamos de toda la gestión, limpieza, precios y huéspedes. Tú solo recibes el dinero.
            </p>
          </div>

          <div className="bg-white/95 backdrop-blur-sm rounded-lg p-8 shadow-2xl">
            <h3 className="font-['Andrea'] text-2xl lg:text-3xl font-bold text-[#2C3E50] mb-2">
              Recibe tu estimación gratuita
            </h3>
            <p className="font-['Satoshi'] text-sm text-gray-600 mb-6">
              Descubre cuánto puedes ganar con tu propiedad
            </p>
            
            <form onSubmit={handleSubmit} data-readdy-form className="space-y-4">
              <div>
                <label htmlFor="nombre" className="block font-['Satoshi'] text-sm font-medium text-gray-700 mb-2">
                  Nombre completo
                </label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#2C3E50] focus:border-transparent outline-none transition-all font-['Satoshi'] text-sm"
                  placeholder="Tu nombre"
                />
              </div>

              <div>
                <label htmlFor="email" className="block font-['Satoshi'] text-sm font-medium text-gray-700 mb-2">
                  Correo electrónico
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#2C3E50] focus:border-transparent outline-none transition-all font-['Satoshi'] text-sm"
                  placeholder="tu@email.com"
                />
              </div>

              <div>
                <label htmlFor="telefono" className="block font-['Satoshi'] text-sm font-medium text-gray-700 mb-2">
                  Teléfono móvil
                </label>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#2C3E50] focus:border-transparent outline-none transition-all font-['Satoshi'] text-sm"
                  placeholder="+34 600 000 000"
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#2C3E50] text-white font-['Satoshi'] font-semibold py-4 px-6 rounded-md hover:bg-[#34495E] transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Enviando...' : 'Recibe tu estimación gratuita'}
              </button>

              {submitMessage && (
                <div className={`mt-4 p-4 rounded-md ${submitMessage.includes('Gracias') ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'}`}>
                  <p className="font-['Satoshi'] text-sm">{submitMessage}</p>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
